import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import LoginContantData from "../../components/loginContantData/LoginContantData";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleDark } from "../../redux/layout";
import { Formik, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from 'yup';
import { BiPhone, BiSun, BiMoon, BiEnvelope, BiSolidMapPin, BiRefresh, BiUser, BiLockOpen } from "react-icons/bi";
import { getGeoLocation } from "../../utils/geoLocation";
import * as urls from '../../utils/urlConst';
import toastNotify from "../../utils/toastNotify";
import axios from "axios";
import { setChechSum, removeLoginSession, getBankData } from "../../utils/common";
import { BiLoader } from "react-icons/bi";
import Textfield from "../../components/textField/TextField";
import { getBrowserDetails } from "../../utils/common";
import FullScreenLoader from "../../components/FullScreenLoader";
import RecaptchaV2 from "../../components/RecaptchaV2";
import useRecaptchaV3 from "../../components/RecaptchaV3";
import HelpdeskIcon from "../../components/HelpdeskIcon";
import { exceptionLog } from "../../utils/common";
import { getCaptchaCode } from "../../apiService/apiService";
import { makeRequest } from "../../utils/makeRequest";
const packageJson = require("./../../../../package.json");

const Login = () => {
  const bankDtl: any = getBankData();
  const isDark = useSelector((state: any) => state.layout.isDark);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const bankLogo = useSelector((state: any) => state.layout.bankLogo);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const isFullLoader = useSelector((state: any) => state.auth.isLoader);
  const [token, setToken] = useState<string>("");
  const [submitEnabled, setSubmitEnabled] = useState<boolean>(bankDtl?.CaptchaVersion === "V3" ? true : false);
  const executeRecaptcha = useRecaptchaV3(bankDtl?.CaptchaVersion === "V3" ? bankDtl?.SiteKey : "", bankDtl?.CaptchaType);
  const currentVersion = packageJson.version;
  const [isCaptchaLoader, setIsCaptchaLoader] = useState<boolean>(false);
  const [captchaDtl, setCaptchaDtl] = useState<any>(null);

  useEffect(() => {
    if (token.length) {
      setSubmitEnabled(true);
    }
  }, [token])


  const getRegularCaptcha = async () => {
    if (bankDtl?.CaptchaType === "R") {
      setIsCaptchaLoader(true);
      const data = await getCaptchaCode()
      setIsCaptchaLoader(false);
      setCaptchaDtl(data);
    }
  }


  useEffect(() => {
    getRegularCaptcha();
  }, [bankDtl?.CaptchaType]);

  useEffect(() => {
    removeLoginSession();
    localStorage.removeItem('user_profile');
    localStorage.removeItem('pop-up-announcement');
    localStorage.removeItem('pop-up-circular');
  }, []);

  // in this get location of login user.
  async function navigationFunc() {
    await getGeoLocation();
  };

  // ------------------------------------ this function called Login API start ---------------------------------------
  const LoginSubmit = async (val: any, resetForm: any) => {
    const getLoction: any = localStorage.getItem('location');
    const location = JSON.parse(getLoction);
    const getIdentifyData: any = localStorage.getItem('_identityData');
    const identifyData = JSON.parse(getIdentifyData);
    const browserDtl = getBrowserDetails();
    var reCaptchaToken: any;

    try {

      setIsLoader(true);
      if (bankDtl?.CaptchaVersion === "V3" && bankDtl?.CaptchaType === "G") {
        reCaptchaToken = await executeRecaptcha("login");
      };

      const payload = {
        Domain: window.location.hostname,
        IpAddress: identifyData.ip,
        MobileNo: bankDtl?.ClientLoginType !== "Y" ? val.mobileNo : "",
        UserName: bankDtl?.ClientLoginType === "Y" ? val.username : "",
        Password: bankDtl?.ClientLoginType === "Y" ? val.password : "",
        BankCode: bankDtl?.BankCode,
        CaptchaType: bankDtl?.CaptchaType,
        Imei: "N/A",
        Version: currentVersion,
        Device: "Web",
        Channel: "Web",
        DeviceIpv6: "N/A",
        DeviceId: "N/A",
        DeviceMac: 'N/A',
        DeviceName: browserDtl.os.name,
        DeviceUserName: 'N/A',
        Latitude: location?.latitude.toString() || "",
        Longitude: location?.longitude.toString() || "",
        Browser: browserDtl.browser.name,
        CaptchaToken: bankDtl?.CaptchaType === "G" ? bankDtl.CaptchaVersion === "V3" ? reCaptchaToken : token : "",
        CaptchaCode: bankDtl?.CaptchaType === "R" ? val.enterCaptcha : "",
        CaptchaSessionId: bankDtl?.CaptchaType === "R" ? captchaDtl?.sessionId : "",
      }

      const checksum = setChechSum(JSON.stringify(payload));
      await axios({
        method: "POST",
        url: urls.loginUrl,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          "checksum": checksum,
          'Authorization': 'Basic ' + btoa(process.env.REACT_APP_AUTHENTICATION_USERNAME + ':' + process.env.REACT_APP_AUTHENTICATION_PASSWORD),
        },
      }).then((result: any) => {
        if (result.data.STATUS === "0") {
          const response = result.data?.RESPONSE[0];
          if (response.Flag === 'Register') {
            navigate("/registration", {
              state: {
                response: response,
              }
            });
            resetForm();
            return toastNotify(result.data.MESSAGE, "success");
          } else {
            navigate("/otp", {
              state: {
                response: { ...response, Flag: 'Login', UserName: payload.UserName },
              }
            });
            resetForm();
            return toastNotify(result.data.MESSAGE, "success");
          }
        } else {
          toastNotify(result.data.MESSAGE, "error");
          getRegularCaptcha();
          resetForm();
        }
      });
    } catch (error) {
      await exceptionLog(error, "login", "Y");
    } finally {
      setIsLoader(false);
    }
  }

  const handleToken = (token: string) => {
    setToken(token);
  };

  const [isDocLoader, setIsDocLoader] = useState<boolean>(false);


  const downloadUserManual = async () => {

    const getLoction: any = localStorage.getItem('location');
    const location = JSON.parse(getLoction);
    const getIdentifyData: any = localStorage.getItem('_identityData');
    const identifyData = JSON.parse(getIdentifyData);
    const browserDtl = getBrowserDetails();

    try {
      setIsDocLoader(true);

      const payload = {
        Domain: window.location.hostname,
        IpAddress: identifyData.ip,
        Imei: "N/A",
        Version: currentVersion,
        Device: "Web",
        Channel: "Web",
        DeviceIpv6: "N/A",
        DeviceId: "N/A",
        DeviceMac: 'N/A',
        DeviceName: browserDtl.os.name,
        DeviceUserName: 'N/A',
        Latitude: location?.latitude.toString() || "",
        Longitude: location?.longitude.toString() || "",
        Browser: browserDtl.browser.name,
      };
      const config = {};

      await makeRequest('POST', urls.getAuthUserManual, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE[0];

          const base64 = "data:application/pdf;base64," + response.UserManual;

          const link = document.createElement("a");
          link.href = base64;
          link.setAttribute("download", "CMS_Client_User_Manual.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();

        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Download Manual", "N");
      }
    } finally {
      setIsDocLoader(false);
    }
  };

  return (
    <>
      <div className="bg-login"></div>

      <div
        style={{ height: "100vh" }}
        className="d-flex justify-content-center align-items-center login-page flex-column"
      >
        <Card style={{ minWidth: "350px", width: "60%" }}>
          <Card.Body>
            <Row>
              <Col
                md={6}
                className="d-none d-md-flex"
                style={{ flexDirection: "column", justifyContent: "center" }}
              >
                <LoginContantData />
              </Col>
              <Col md={6} className="d-flex justify-content-center align-items-center">
                <div className={`p-3 regitrasationFormContainer w-100 `}>
                  <div className="company-logo d-flex justify-content-center my-3">
                    <img
                      src={bankLogo.loginLogo}
                      alt="company-logo"
                      style={{ width: bankLogo.loginLogoWidth, height: bankLogo.loginLogoHeight }}
                    />
                  </div>

                  <div className="d-flex fw-bold mt-4 justify-content-center gap-1">
                    <HelpdeskIcon style={{}} />
                    <h3 className="border-start border-3 ps-2 text-lg text-center">Login</h3>
                  </div>

                  <Formik
                    initialValues={{
                      mobileNo: '',
                      username: '',
                      password: '',
                      enterCaptcha: ""
                    }}
                    validationSchema={
                      Yup.object({
                        mobileNo: bankDtl?.ClientLoginType !== "Y" ? Yup.string().trim().matches(/^[6789]\d{9}$/, 'Please enter valid mobile no.').max(10, 'Mobile No. must be 10 characters').min(10, 'Mobile No. must be 10 characters').required('Mobile No. is required') : Yup.string(),
                        username: bankDtl?.ClientLoginType === "Y" ? Yup.string().required('Username is a required field') : Yup.string(),
                        password: bankDtl?.ClientLoginType === "Y" ? Yup.string().required('Password is required field') : Yup.string(),
                        enterCaptcha: bankDtl?.CaptchaType === "R" ? Yup.string().required('Captcha is required field') : Yup.string(),
                      })
                    }
                    onSubmit={(values, { resetForm }) => {
                      navigationFunc();
                      LoginSubmit(values, resetForm)
                    }}
                  >
                    {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
                      return (
                        <form action="#" className="mt-4" onSubmit={handleSubmit}>
                          {bankDtl?.ClientLoginType !== "Y" ?
                            <div>
                              <Textfield
                                label="Mobile No"
                                name="mobileNo"
                                id="mobileNo"
                                size="small"
                                required
                                tabIndex={1}
                                pattern="[0-9]*"
                                maxLength={10}
                                value={values.mobileNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;
                                  const regex = /^[0-9]*[.,]?[0-9]*$/;
                                  if (regex.test(value.toString())) {
                                    setFieldValue("mobileNo", value);
                                  }
                                }}
                                onBlur={handleBlur}
                                IconProp={BiPhone}
                              />
                              <ErrorMessage name="mobileNo" className='error-msg' component="div" />
                            </div>
                            : <>
                              <div>
                                <Textfield
                                  label="Username"
                                  name="username"
                                  id="username"
                                  size="small"
                                  tabIndex={1}
                                  maxLength={25}
                                  required
                                  disabled={isLoader}
                                  value={values.username}
                                  onChange={(e) => setFieldValue("username", e.target.value.trim())}
                                  onBlur={handleBlur}
                                  IconProp={BiUser}
                                />
                                <ErrorMessage name="username" className='error-msg' component="div" />
                              </div>

                              <div className="mt-3">
                                <Textfield
                                  label="Password"
                                  type="password"
                                  name="password"
                                  id="password"
                                  size="small"
                                  tabIndex={2}
                                  maxLength={25}
                                  required
                                  disabled={isLoader}
                                  value={values.password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  IconProp={BiLockOpen}
                                />
                                <ErrorMessage name="password" className='error-msg' component="div" />
                              </div>

                              <div className="d-flex justify-content-end my-2">
                                <Link to="/forgotpassword" state={{ Flag: "Login" }} className="text-sm">
                                  Forgot Password ?
                                </Link>
                              </div>
                            </>}

                          {bankDtl?.CaptchaType === "R" &&
                            <Row className="mt-3">
                              <Col md={6}>
                                <div className="d-flex">
                                  <div className="form-control form-control-sm p-1 capcha-input"
                                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: "#f0f0f0", height: 35 }}>
                                    <img src={captchaDtl?.captchaImage ? "data:image/jpeg;base64," + captchaDtl?.captchaImage : undefined} alt="captcha" className="w-100 h-100" />
                                  </div>
                                  <Button variant='orange' disabled={isCaptchaLoader} type="button" className="btn-sm" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                    onClick={() => {
                                      getRegularCaptcha();
                                    }}>
                                    {isCaptchaLoader ? <BiLoader className="bx-spin text-white text-lg" /> : <BiRefresh className='text-white text-lg' />}
                                  </Button>
                                </div>
                              </Col>
                              <Col md={6} className="mt-md-0 mt-3">
                                <Textfield
                                  label="Captcha"
                                  name="enterCaptcha"
                                  id="enterCaptcha"
                                  size="small"
                                  tabIndex={2}
                                  maxLength={8}
                                  required
                                  disabled={isLoader}
                                  value={values.enterCaptcha}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <ErrorMessage name="enterCaptcha" className='error-msg' component="div" />
                              </Col>
                            </Row>
                          }

                          {bankDtl && bankDtl?.CaptchaType === "G" &&
                            <div>
                              {bankDtl?.CaptchaVersion === "V2" &&
                                <RecaptchaV2 sitekey={bankDtl?.SiteKey} callback={handleToken} />
                              }
                            </div>
                          }

                          <div className="mt-4">
                            <Button
                              type="submit"
                              className="w-100"
                              variant="orange"
                              disabled={bankDtl.CaptchaVersion === "V2" ? !submitEnabled : isLoader ? isLoader : false}
                            >
                              {!isLoader ? 'Login' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}
                            </Button>
                          </div>

                          {bankDtl.ClientLoginType === "Y" &&
                            <div className="text-sm text-center mt-3">Don't have an account ? <Link to="/registration">Create Account.</Link></div>
                          }

                          <div className="d-flex justify-content-center">
                            <Button type="button" variant="transparent" onClick={() => { bankDtl.UserManualType === "R" ? downloadUserManual() : navigate("/loginusermannual") }} className="text-sm text-center mt-3 mx-auto p-0 text-orange border-0">
                              {!isDocLoader ? 'Do you need help ?' : <><BiLoader className='icon-loader text-orange text-lg' /> Loading...</>}
                            </Button>
                          </div>
                        </form>
                      )
                    }}
                  </Formik>


                </div>
              </Col>
            </Row>
            <hr />
            <div className="mb-0 text-xs text-slate-700 text-center">
              <BiPhone /> +91-{bankDtl?.MobileNo} | <BiEnvelope /> {bankDtl?.EmailId}
            </div>
            <div className="mb-0 text-xs text-slate-700 text-center" >
              <BiSolidMapPin /> Registration Address : {bankDtl?.Address}, {bankDtl?.CityName}, {bankDtl?.StateName} - {bankDtl?.PinCode}
            </div>
            <div className="mt-2">
              <p className="text-xs text-center mb-0">
                Developed by {" "}
                <Link to="https://suretytelco.com/" target="_blank">
                  SURETY-TELCO
                </Link>
                {" "} | {" "}
                Sales by {" "}
                <Link to="https://soft-techsolutions.com/" target="_blank">
                  SOFT-TECH SOLUTION
                </Link>
              </p>
              <p
                className="mt-1 text-xs text-center mb-0"
              >
                Copyrights © 2014 - {new Date().getFullYear()}
                {" "} | {" "}
                All Right Reserved
              </p>
            </div>
          </Card.Body>
        </Card>

        <div className="position-absolute d-flex align-items-center" style={{ top: 20, right: 20 }}>
          <div
            className="login-icon rounded-circle ms-2"
            onClick={() => dispatch(handleDark(!isDark))}
          >
            {isDark ? <BiSun /> : <BiMoon />}
          </div>
        </div>

      </div >
      {isFullLoader && <FullScreenLoader />}
    </>
  );
};

export default Login;
